<template>
  <div class="w-52 overflow-hidden flex flex-col gap-y-1">
    <el-input
      v-model="state.params.keywords"
      clearable
      placeholder="关键字"
      @keyup.enter="onLoad()"
      @clear="onLoad()"
    >
      <template #suffix>
        <el-icon
          @click="onLoad()"
          color="#a2a2a2"
          title="搜索"
          class="font-bold cursor-pointer hover:opacity-60"
          ><Search
        /></el-icon>
      </template>
    </el-input>
    <div class="flex-1 overflow-y-auto">
      <el-tree
        style="max-width: 600px"
        :data="state.bmData"
        :props="{
          children: 'children',
          label: 'name',
        }"
        default-expand-all
        check-on-click-node
        :expand-on-click-node="false"
        @node-click="onNodeClick"
      >
        <template #default="{ node, data }">
          <div class="flex items-center gap-x-1">
            <li
              v-if="data.status != 1"
              class="text-white bg-red-400 rounded-sm"
              style="padding: 2px; font-size: 10px"
            >
              禁
            </li>
            <text
              :class="data.status != 1 ? 'text-gray-400' : ''"
              class="hover:text-primary"
              >{{ node.label }}</text
            >
          </div>
        </template>
      </el-tree>
    </div>
  </div>
</template>

<script>
import { onMounted, reactive } from "vue";
import { data_getDepartment_tree } from "@/http/data";
import { companyName } from "@/utils/base";

export default {
  setup(props, { emit }) {
    const state = reactive({
      params: {},
    });
    onMounted(() => {
      onLoad();
    });

    const onLoad = () => {
      delete state.bmData;

      data_getDepartment_tree().then((res) => {
        if (res.status == 200)
          state.bmData = [
            {
              id: null,
              name: companyName,
              status: 1,
              children: res.data?.data || [],
            },
          ];
      });
    };

    const onNodeClick = (data) => {
      emit("node-change", data.id);
    };
    return { state, onLoad, onNodeClick };
  },
};
</script>

<style lang="less" scoped></style>
